module.exports = __webpack_public_path__ + "static/media/contraindications.d0eab9b2.md";